'use client';

import { useEffect } from 'react';
import { getCookieWckAuthData } from '@wconcept/wconcept-common/utils/cookie';
import {
  addAsIsMWebDomain,
  addAsIsPcWebDomain,
  currentUrl,
} from '@wconcept/wconcept-common/utils/domainUtil';
import useHistoryRouter from '@hooks/useLinkTo';
import useGlobalState from './useGlobalState';

/**
 * 쿠키 만료 체크 훅
 * 기준일(당월 1일 02:00:00) 이후이고 cookieCreateDate가 기준일 이전이면 로그인 페이지로 리다이렉트
 */
function useCookieExpirationCheck() {
  const { linkTo } = useHistoryRouter();
  const { isMobile } = useGlobalState();

  const checkCookieExpiration = async () => {
    // 이미 리다이렉트를 거쳤는지 체크 (무한 루프 방지)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('redirected')) {
      // URL에서 파라미터 제거
      urlParams.delete('redirected');
      const newSearch = urlParams.toString();
      const newUrl = `${window.location.pathname}${
        newSearch ? `?${newSearch}` : ''
      }${window.location.hash}`;
      window.history.replaceState({}, '', newUrl);
      return;
    }
    // 운영 환경에서 2025년 12월 1일 이전이면 동작하지 않음
    const now = new Date();
    const prodBaseDate = new Date(2025, 11, 1, 0, 0, 0); // 2025년 12월 1일 00:00:00
    if (process.env.NEXT_PUBLIC_MODE === 'prod' && now < prodBaseDate) {
      return;
    }

    // 기준일 : 현재 시간 기준 당월 1일 02:00:00
    const baseDate = new Date();
    baseDate.setDate(1);
    baseDate.setHours(2, 0, 0);
    const baseDateString = baseDate.toISOString();

    // 현재시간은 기준일 이후이면서 cookieCreateDate는 기준일 이전일때 호출
    if (new Date() > baseDate) {
      const wckAuthData = await getCookieWckAuthData();
      if (
        wckAuthData &&
        wckAuthData.cookieCreateDate &&
        wckAuthData.cookieCreateDate < baseDateString
      ) {
        // 현재 URL에 cookie_checked 파라미터 추가
        const currentUrlWithParam = `${currentUrl()}${
          currentUrl().includes('?') ? '&' : '?'
        }redirected=1`;

        const targetUrl = `${await (isMobile
          ? addAsIsMWebDomain
          : addAsIsPcWebDomain)('/Bridge')}?rUrl=${encodeURIComponent(
          currentUrlWithParam
        )}`;

        if (targetUrl) {
          linkTo.push({
            url: targetUrl,
          });
        }
      }
    }
  };

  useEffect(() => {
    checkCookieExpiration();
  }, []);
}

export default useCookieExpirationCheck;
